{
  "add": "إضافة",
  "add-barn-first-description": "قم اولاً بتسجيل الحظائر في إعداداتك الخاصة بك . من ثم يمكنك تسجيل الوصول هنا",
  "add-cycle": "قم بإضافة دورة",
  "add-day-old-chick-first-description": "قم اولاً بتسجيل الوصول ومن ثم يمكنك تسجيل المغادرة",
  "age": "العمر",
  "amount": "الكمية",
  "app": {
    "cycles": "الدورات",
    "deliveries": "الطلبيات",
    "reports": "التقارير",
    "settings": "الإعدادات",
    "products": "المنتجات",
    "farmer-insights": "رؤية المزارع",
    "advices": "نصائح ومراجع",
    "feed-advice": "نصيحة تغذوية",
    "reference-value-sheet": "ورقة القيمة المرجعية",
    "standard-reference-value-sheet": "أوراق القيم المرجعية القياسية",
    "reference-scheme": "نصائح تغذوية مرجعية",
    "management": "الإداراة",
    "performance": "الأداء",
    "within-cycle-performance": "الأداء خلال الدورة"
  },
  "farmer-insights": {
    "kpiGroups": {
      "TechnicalPerformance": "الأداء الفني",
      "FinancialPerformance": "الأداء المالي",
      "ArrivalAndDeparture": "الوصول والمغادرة",
      "FeedConsumption": "إستهلاك العلف",
      "WellBeing": "الرفاهية",
      "RevenueAndCost": "الإيرادات و التكاليف"
    },
    "description": "رؤية حالية عن حالة المزرعة!",
    "locations": "المواقع",
    "location": "الموقع",
    "cycles": "الدورات",
    "barns": "الحظائر",
    "detail-level": "مستوى التفاصيل",
    "display-type": "أسلوب العرض",
    "kpis-name": "مؤشرات الأداء الرئيسية",
    "table": "جدول",
    "chart": "مخطط بياني",
    "kpi-selection": "إختيار مؤشرات الأداء الرئيسية",
    "aggregation": {
      "Sum": "التراكمي",
      "Average": "المتوسط",
      "Min": "الحد الادنى",
      "Max": "الحد الاعلى"
    },
    "custom-footers": {
      "end-total": "المجموع النهائي",
      "same-period": "مقارنة مع <Tenant> في نفس الفترة ( القطعان :",
      "last-weeks": "مقارنة مع <Tenant> آخر 10 أسابيع ( القطعان:",
      "customer-average-selected-period": "معدل الفترة المحددة من قبل العميل ( القطعان:"
    },
    "no-data": {
      "title": "لا يوجد رؤية حالية عن البيانات",
      "description": "تظهر البيانات التوقعية عند وجود قطيع واحد أو أكثر"
    },
    "no-benchmark": "بيانات غير كافية لتحديد (مطلوب 15 قطيع على الأقل).",
    "benchmark-title": "<Tenant>",
    "benchmark-selected-period": "الفترة المحددة",
    "benchmark-last-weeks": "آخر 10 أسابيع",
    "norm": "معيار",
    "benchmark-settings": "إعدادات المقارنة",
    "settings": {
      "header": "الفلاتر/المرشحات",
      "title": "إعدادات المقارنة",
      "subtitle": "هنا يمكنك تحديد مع أي من المعايير تريد مقارنة القطيع الخاص بك \" إذا لم تكن في الوضع التفصيلي \"",
      "selected-period-label": "عرض معايير أجريفيرم للفترة التي تم اختيارها",
      "selected-period-label-agravis": "عرض معايير Agravis للفترة التي تم اختيارها",
      "last-weeks-label": "عرض معايير أجريفيرم آخر10 أسابيع",
      "last-weeks-label-agravis": "عرض معايير Agravis آخر10 أسابيع",
      "customer-average-selected-period-label": "عرض معدل الفترة المحددة من قبل العميل",
      "none": "لا شيء",
      "select-multiple-benchmark-label": "يمكنك تحديد معايير متعددة",
      "select-one-benchmark-label": "يمكنك تحديد معيار واحد فقط",
      "non-detailed-view-label": "آراء غير مفصلة",
      "detailed-view-label": "وجهات النظر التفصيلية"
    },
    "reset-filters": "إعادة تعيين مؤشر الأداء الرئيسي",
    "to": "إلى",
    "maxPrintWarning": {
      "title": "تنبيه",
      "message": "لقد حددت أكثر من الحد الاقصى لعدد مؤشرات الأداء الرئيسية التي يمكنك طباعتها.  سيظهر العدد الأول من مؤشرات الأداء الرئيسية القابلة للطباعة عند الطباعة. العدد الحالي المحتمل لمؤشرات الأداء الرئيسية عند الطباعة :"
    },
    "kpis": {
      "DayOldChicks": "عدد الكتاكيت",
      "DayOldChicksPrice": "سعر الكتاكيت الوافدين",
      "TotalDeparture": "المغادرة الكاملة",
      "DepartureWeight": "وزن المغادرة",
      "SlaughterWeight": "وزن الذبح",
      "Revenue": "الإيرادات",
      "FeedBalance": "إستهلاك العلف",
      "FeedBalancePrice": "تكلفة إستهلاك العلف",
      "LossPercentage": "نسبة الخسارة",
      "ReplacementPercentage": "نسبة الإستبدال",
      "FeedConversion": "التحويل الغذائي",
      "FeedConversion1500": "التحويل الغذائي 1500",
      "AverageWeightInGram": "معدل الوزن",
      "WeightedAverageAgeInDays": "معدل الأعمار بالأيام",
      "WeightedAverageGrowthPerDay": "النمو",
      "ProductionNumber": "عدد الإنتاج",
      "DayOldChicksPerSquareMeter": "عدد الكتاكيت لكل متر مربع",
      "FeedUsageInKgPerSquareMeter": "إستهلاك العلف لكل متر مربع",
      "FeedConsumptionPricePer100Kg": "تكلفة إستهلاك العلف لكل 100 كيلو جرام",
      "PaidAmountPerKg": "الإيرادات لكل كيلو جرام",
      "NettoRevenue": "صافي الإيرادات",
      "NettoRevenuePerChick": "صافي الإيرادات لكل كتكوت",
      "NettoRevenuePerSquareMeterPerDay": "صافي الإيرادات لكل متر مربع لكل يوم",
      "RejectionRate": "نسبة الرفض",
      "PricePerDayOldChick": "تكلفة الكتكوت",
      "FeedBalanceMixProduct": "إستهلاك العلف الممزوج",
      "FeedBalanceRawProduct": "إستهلاك العلف من المواد الخام",
      "DeliveredKgPerSquareMeter": "الوزن بالكيلو جرام لكل متر مربع",
      "NettoRevenuePerSquareMeter": "صافي الإيرادات للمتر المربع",
      "FeedConsumptionPerDeliveredKg": "تكاليف العلف لكل كيلو جرام",
      "DayOldChicksWeight": "وزن الكتكوت",
      "WeightedHeelDermatitis": "إحتمالية إلتهاب كعب القدم",
      "WeightedFootpadLesionNonePercentage": "درجة 0",
      "WeightedFootpadLesionModeratePercentage": "درجة 1",
      "WeightedFootpadLesionSeverePercentage": "درجتان",
      "TotalLoss": "الخسارة",
      "WeightedFootpadLesionScore": "درجة آفة وسادة القدم",
      "FeedBalanceRawPrice": "تكلفة إستهلاك العلف من المواد الخام",
      "FeedBalanceMixPrice": "تكلفة إستهلاك العلف الممزوج",
      "PartialDeparture": "المغادرة بالتجزئة",
      "FullDeparture": "المغادرة الكلية",
      "NettoProfitInclOtherCosts": "صافي الربح شامل التكاليف الأخرى",
      "DayOldChicksPriceExclDiscounts": "خصومات حصرية سعر وصول الفرخ",
      "RevenueExclDiscounts": "الإيرادات باستثناء الخصومات",
      "FeedBalancePriceExclDiscounts": "خصومات حصرية على سعر استهلاك العلف"
    },
    "data-view-types": {
      "PerLocation": "لكل موقع",
      "PerCycle": "لكل دورة",
      "PerCycleBarn": "لكل دورة في كل حظيرة",
      "PerLocationBarn": "لكل مستقر"
    },
    "customer-average-selected-period": "معدل الفترة المحددة من قبل العميل",
    "show-more": "أظهر المزيد",
    "show-less": "إجعلها تظهر بشكل أقل"
  },
  "within-cycle-performance": {
    "advice_and_reference-value-sheet": "نصيحة تغذوية و ورقة القيمة المرجعية",
    "kpi": "مؤشر الأداء الرئيسي",
    "kpis": {
      "IndoorTemperature": "درجة الحرارة الداخلية",
      "IndoorHumidity": "درجة الرطوبة الداخلية",
      "MortalityPercentage": "نسبة النفوق",
      "FeedIntakePerChick": "إستهلاك العلف (لكل كتكوت)",
      "WaterIntakePerChick": "إستهلاك المياه (لكل كتكوت)",
      "WeightGainPerChick": "الزيادة الوزنية (لكل كتكوت)",
      "WaterToFeedRatio": "نسبة المياه إلى العلف",
      "FeedConversionRate": "معدل التحويل الغذائي",
      "LitterQuality": "جودة الأرضية",
      "LitterQualityCaked": "متكتلة",
      "LitterQualityLoose": "رخوة",
      "LitterQualityWet": "مبللة",
      "BodyWeight": "وزن الجسم",
      "GrowthPrediction": "توقع النمو",
      "IndoorOutdoorTemperature": "درجة الحرارة الداخلية والخارجية",
      "IndoorOutdoorHumidity": "الرطوبة الداخلية والخارجية",
      "OutdoorTemperature": "درجة الحرارة الخارجية",
      "OutdoorHumidity": "الرطوبة الخارجية"
    },
    "no-data": "لا تتوفر بيانات."
  },
  "area": "المساحة",
  "arrival-date": "تاريخ الوصول",
  "avined": "أفيند",
  "balance": {
    "add-manual-delivery": "إضافة طلبية",
    "balance-row": "صف التوازن",
    "barn-distribution": {
      "available-in-this-cycle": "متاح خلال هذه الدورة",
      "change-flock-allocation": "تغيير توزيع القطيع",
      "currently": "حالياً",
      "delivery-line-info": "معلومات خط الإستلام",
      "flock-allocation": "توزيع القطيع",
      "kg-per-chick": "كيلو جرام لكل كتكوت",
      "of-which-remaining": "المتبقي منها",
      "total-should-be": "يجب ان يكون مجموع الكميات",
      "totally-delivered": "تم تسليمها بالكامل",
      "usage-in-kg": "الإستخدام (كيلو جرام)",
      "usage-in-other-cycles": "الإستخدام بالدورات الأخرى",
      "usage-in-this-cycle": "الإستخدام خلال هذه الدورة",
      "total": "المجموع",
      "totalRaw": "إجمالي العلف الخام",
      "totalCompound": "إجمالي العلف المركب"
    },
    "consumption": "الإستهلاك (كيلو جرام)",
    "delivery-date": "تاريخ الإستلام",
    "empty-day-old-chick-description": "اولاً قم بإدخال الوصول ومن ثم يمكنك إدخال صفوف الموازين هنا",
    "empty-day-old-chick-title": "لا يوجد طلبيات",
    "empty-description": "إنقر على \"أعد الحساب\" لكي يتم عرض الموازنة",
    "empty-title": "لم يتم إيجاد صفوف الموازنة",
    "manual-add": "يدوي",
    "multiple-deliveries": "طلبيات متعددة",
    "price": "السعر",
    "product": "المنتج",
    "quantity": "الكمية (كيلو جرام)",
    "recalculate": "أعد الحساب",
    "recalculate-warning": {
      "text": "سيتم إعادة تحميل جميع طلبيات العلف للدورة الحالية. سيتم إضافة أي طلبيات جديدة. سيتم ضبط جميع الكميات المتبقية على صفر",
      "title": "هل أنت متأكد من أنك تريد إعادة الحساب"
    },
    "remainder": "الباقي (كيلو جرام)",
    "remainder-greater-than-quantity": "لا يمكن أن يكون الباقي أكبر من الكمية",
    "remainder-less-than-zero": "لا يمكن أن يكون الباقي أقل من صفر",
    "remainder-less-than-quantity": "لا يمكن أن يكون الباقي أقل من الكمية",
    "remainder-greater-than-zero": "لا يمكن أن يكون الباقي أكبر من صفر",
    "remainder-other-than-zero": "لا يمكن أن يكون الباقي غير صفر",
    "remainder-NaN": "الباقي ليس رقماً صحيحاً",
    "pending-changes-warning": {
      "title": "لم يتم حفظ التغييرات",
      "message": "لم تقم بحفظ التغييرات على موازنتك",
      "confirmText": "متابعة من غير حفظ",
      "cancelText": "إلغاء"
    },
    "save-confirm": {
      "title": "حفظ الموازنة",
      "text": "الموازنة لم يتم إنهائها بعد. من خلال حفظها و جعلها نهائية, يمكنك إعطاء الموازنة حالة \"نهائية\". اذا لم تكتمل الموازنة, فعليك اختيار حفظ. بهذا يمكنك حفظ الموازنة بالحالة \"الأولية\".",
      "alert": "إنهاء الموازنة هو امر مهم لانه عندها فقط سيتم إعتبار الجولة كاملة في التقارير"
    },
    "edit-confirm": {
      "title": "تعديل الموازنة",
      "text": "إذا قمت باختيار تغيير الموازنة سوف تتغير حالة الموازنة من \"نهائية\" الى \"أولية\". يمكنك إجراء تغييراتك و جعل الموازنة نهائية مرة أخرى.",
      "alert": "من المهم إعادة إنهاء الموازنة بعد التغييرات لأن الجولة ذات الموازنة الأولية لن يتم إعتبارها مكتملة في التقارير."
    },
    "not-finalized": {
      "title": "الموازنة لم تنتهي بعد",
      "message": "الموازنة لم تنتهي بعد. عن طريق \"حفظ و انهاء\" يمكنك انهاء الموازنة على الفور"
    },
    "save-and-finalize": "حفظ و إنهاء",
    "save": "حفظ",
    "edit": "تعديل",
    "edit-balance": "تعديل الموازنة",
    "delete-confirm": {
      "text": "هذا سوف يؤدي إلى إزالة هذه الطلبية من قائمتك. الطلبيات التي يتم إستخدامها في الموازنات لن يتم إزالتها.",
      "title": "هل أنت متأكد من أنك تريد حذف هذه الطلبية"
    },
    "has-empty-barns": {
      "title": "تم العثور على صفوف التوازن الخاطئة",
      "message": " العثور على صفوف التوازن حيث لم يتم تعيين حظيرة. سيتم حل هذه المشكلة عن طريق إعادة حساب الرصيد."
    },
    "barn-name": "الحظيرة",
    "invoice-date": "تاريخ الفاتورة",
    "invoice-number": "رقم الفاتورة",
    "delivery-number": "معرف التسليم"
  },
  "balance-item": {
    "add-product": "إضافة بشكل يدوي",
    "error-product-selected": "إختيار منتج",
    "no-products": "لم يتم إيجاد منتجات موجودة",
    "product": "منتج"
  },
  "balance-item-delivery": {
    "amount": "الكمية لكل حظيرة",
    "current-usage": "الإستخدام الحالي",
    "error-amount": "قم بإدخال الكمية",
    "error-no-amount": "قم بإدخال الكمية لحظيرة واحدة على الأقل",
    "remaining-of": "المتبقي من"
  },
  "balance-item-manual": {
    "amount": "الكمية لكل حظيرة",
    "delivery-date": "تاريخ الإستلام",
    "error-amount": "قم بإدخال الكمية",
    "error-delivery-date": "قم بإدخال تاريخ الإستلام",
    "error-no-amount": "قم بإدخال الكمية لحظيرة واحدة على الأقل",
    "error-price": "قم بإدخال صافي التكلفة",
    "error-product-title": "قم بإدخال وصف المنتج",
    "error-supplier-name": "قم بإدخال إسم المزود",
    "error-vat": "قم بإدخال نسبة ضريبة القيمة المضافة",
    "price": "صافي التكلفة ( دون الضريبة )",
    "product-title": "وصف المنتج",
    "product-type-multiple": "منتج ممزوج",
    "supplier-name": "إسم المزود",
    "vat": "ضريبة القيمة المضافة"
  },
  "balance-summary": {
    "consumption-per-delivered-chick": "الإستهلاك لكل كتكوت تم إستلامه",
    "final-stock": "القطيع النهائي (كيلو جرام)",
    "initial-stock": "القطيع البدائي (كيلو جرام)",
    "title": "نبذة عن الموازنة",
    "total": "إجمالي الإستهلاك (كيلو جرام)",
    "delivery-stock": "الطلبية (كيلو جرام)",
    "product": "المنتج"
  },
  "barn": "الحظيرة",
  "barn-item": {
    "area": "مساحة السطح",
    "error-name-duplicate": "إسم الحظيرة هذا قيد الإستخدام بالفعل.  قم بإدخال إسم حظيرة مختلف",
    "error-name-required": "قم بإدخال إسم الحظيرة",
    "error-surface-area": "قم بإدخال مساحة السطح",
    "name": "وصف الحظيرة",
    "animal-group-barn-id": "Animal Group معرف الحظيرة",
    "not-mapped": "(غير معين)"
  },
  "birth-date": "تاريخ الولادة",
  "breed": "السلالة",
  "cadaver": "الجثة",
  "catching": "إصطياد",
  "certification": "IKB",
  "chick-price": "صافي التكلفة لكل كتكوت دون الضريبة",
  "chickens": "الدجاج",
  "chicks-parents-age-in-weeks": "عمر الأمهات (بالأسابيع)",
  "chicks-weight-in-grams": "وزن الكتاكيت (جرام)",
  "close-round": "دورة قريبة",
  "concept": "نوع التربية",
  "costs": "التكاليف",
  "costs-specification": "تفاصيل التكاليف",
  "couple": "القطيع",
  "couple-number": "رقم",
  "couples": "القطعان",
  "customer-id": "هوية العميل",
  "cycle": "دورة",
  "cycle-navigation": {
    "balance": "الموازنة",
    "closure": "إنهاء",
    "day-old-chick": "الإستلام",
    "departure": "المغادرة",
    "general": "نظرة عامة"
  },
  "cycle-number": "رقم",
  "enter-amounts": "قم بإدخال الكميات",
  "n/a": "غير متوفر",
  "cycle-overview": {
    "barn": "الحظيرة",
    "consumption-empty": {
      "description": "قم بإدخال المعلومات لجعل صفوف الموازنة متاحة",
      "title": "لا يوجد صفوف موازنة"
    },
    "daily-performance-empty": {
      "description": "قم بإدخال المعلومات لجعل المراقبات اليومية/ الأسبوعية متاحة",
      "title": "المدخلات غير متاحة"
    },
    "cycle": "الدورة",
    "delete-cycle": "حذف",
    "edit-current-week": "إلتقاط التسجيلات الاسبوعية",
    "weekregistration-overview": "نظرة عامة على التسجيلات الأسبوعية",
    "detailedOverview": "التفاصيل",
    "edit": "تعديل",
    "edit-cycle": "تعديل",
    "option-all-barn": "جميع الحظائر",
    "panel": {
      "add-day-old-chick": "قم بإضافة الوصول",
      "add-departure": "قم بإضافة المغادرة",
      "amount": "الكمية",
      "balance-overview": "نظرة عامة على الموازنة",
      "balance-title": "إستهلاك العلف",
      "birthdate": "تاريخ الولادة",
      "consumption": "الإستهلاك (كيلو جرام)",
      "consumption-per-chick": "الإستهلاك لكل كتكوت (جرام)",
      "date": "تاريخ الإستلام",
      "day-old-chick-overview": "نظرة عامة على الوصول",
      "day-old-chick-title": "الوصول",
      "day-old-chick-total": "إجمالي الوصول",
      "departure-overview": "نظرة عامة على المغادرة",
      "departure-title": "المغادرة",
      "departure-total": "اجمالي المغادرة",
      "departuredate": "تاريخ المغادرة",
      "departureweight": "الوزن عند المغادرة",
      "price": "السعر",
      "price-ex-vat-per-chick": "التكلفة لكل كتكوت ( دون الضريبة )",
      "price-ex-vat": "السعر ( دون الضريبة )",
      "product-title": "اسم العلف",
      "product-type-mixedproduct": "مركب",
      "product-type-rawproduct": "خام",
      "revenue": "الإيرادات",
      "slaughterweight": "الوزن عند الذبح",
      "type": "النوع",
      "type-full": "تخلص كامل",
      "type-manual": "يدوي",
      "type-partial": "تخلص جزئي",
      "type-platform": "برنامج",
      "type-start": "برنامج",
      "total-consumption": "إجمالي الإستهلاك",
      "daily-performance-title": "تسجيلات المراقبة الأسبوعية و اليومية",
      "edit-current-week": "إلتقاط التسجيلات الأسبوعية",
      "cycle-title": "الدورة",
      "discount-title": "الخصومات",
      "discount-overview": "نظرة عامة على الخصم"
    },
    "placeholder": "قم بالإختيار",
    "start-new-cycle": "إبدأ دورة جديدة",
    "weekregistration-download": "تحميل النموذج",
    "weekregistration-upload": "يستورد",
    "weekregistration-select-file": "حدد ملفًا ...",
    "weekregistration-upload-csv-title": "حدد ملف CSV لاستيراده",
    "upload-csv-message": "يجب عدم إزالة الأعمدة من القالب ، حتى لو كانت فارغة. يمكن ترك الحقول فارغة.",
    "upload-csv-notification": "حدد ملف CSV لاستيراده",
    "weekregistration-select-interval-type": "نوع الفاصل الزمني",
    "download-weekly-report": "تقرير أسبوعي",
    "cycle-start-in-future-warning-description": "تاريخ بدء هذه الدورة في المستقبل. ولهذا السبب، لا يمكن تسجيل الملاحظات.",
    "cycle-start-in-future-warning-title": "الدورة لم تبدأ بعد"
  },
  "wdo-labels": {
    "mortality": "نسبة النفوق",
    "feedIntake": "إستهلاك العلف",
    "waterIntake": "إستهلاك المياه",
    "indoorTemperature": "درجة الحرارة الداخلية (سيليسيوس)",
    "outdoorTemperature": "درجة الحرارة الخارجية (سيليسيوس)",
    "indoorHumidity": "درجة الرطوبة الداخلية (%)",
    "outdoorHumidity": "درجة الرطوبة الخارخية (%)",
    "weight": "الوزن (جرام)",
    "litterQuality": "جودة الارضية",
    "litterQualities": {
      "Loose": "نسبة الفضلات الرخوة في الأرضية (%)",
      "Caked": "نسبة الفضلات المتكتلة في الأرضية (%)",
      "Wet": "نسبة الفضلات الرطبة في الأرضية (%)"
    },
    "selection": "اختيار",
    "selectionSmall": "اختيار صغير",
    "selectionLegProblems": "مشاكل اختيار الساق",
    "feedIntakeGramPerBird": "كمية العلف (جرام لكل طائر)",
    "feedIntakeKg": "كمية العلف (كجم)",
    "waterIntakeMililiterPerBird": "كمية الماء (مليلتر لكل طائر)",
    "waterIntakeL": "كمية الماء (لتر)",
    "kilogramSuffix": "كلغ",
    "gramSuffix": "غرام",
    "literSuffix": "لتر",
    "mililiterSuffix": "مليلتر",
    "ageInDays": "العمر بالأيام"
  },
  "wdo-settings": {
    "title": "إعدادات المراقبة اليومية و الأسبوعية",
    "disabled-message": "لا يمكن تغيير هذه الإعدادات لأن تسجيلات الأسبوع قد تم إدخالها",
    "startday-description": "يوم البدء في سياق تاريخ وصول القطعان",
    "startday-label": "إعداد أيام الأسبوع",
    "startday-placeholder": "إختيار يوم البدء",
    "weekly-daily-description": "هنا يمكنك تحديد المعلومات التي تريد إدخالها إما يومية أو أسبوعية",
    "open-settings": "فتح الإعدادات",
    "general-option": {
      "label": "الإعدادات العامة",
      "per-day": "لكل يوم للجميع",
      "per-week": "لكل اسبوع للجميع"
    },
    "setting-option": {
      "off": "إيقاف",
      "per-day": "لكل يوم",
      "per-week": "لكل أسبوع"
    },
    "delete-confirm": {
      "title": "هل أنت متأكد من أنك تريد تغيير هذه الإعدادات",
      "text": "سيتم حذف البيانات للمؤشرات التالية خلال عملية الحفظ"
    }
  },
  "wdo-registration": {
    "all-settings-are-off-title": "لقد تم إغلاق جميع حقول التسجيل",
    "all-settings-are-off-message": "إنتقل أولاً إلى إعدادات الملاحظات الأسبوعية و اليومية في علامة التبويب العام لهذه الدورة و قم بإعداد الإعدادات الخاصة بك",
    "registration": "تسجيلات المراقبة اليومية و الأسبوعية",
    "cycle-date": "تاريخ الوصول",
    "cycle-end-date": "تاريخ إنتهاء الدورة",
    "select-week": "الأسبوع",
    "select-week-placeholder": "اختيار الأسبوع",
    "select-barn": "الحظيرة",
    "select-barn-placeholder": "إختيار الحظيرة",
    "validation-errors": {
      "total-must-be-100": "يجب أن يكون مجموع نسب فضلات الأرضية مساوي ل 100%",
      "date-is-not-valid-title": "تواريخ غير صحيحة في ملف التحميل",
      "date-is-not-valid-description": "توجد بيانات في ملف التحميل ذات يوم / أسبوع أكبر / أصغر من تاريخ انتهاء / تاريخ بدء الدورة. يتم حفظ البيانات مع التاريخ الصحيح."
    },
    "next-day": "اليوم التالي"
  },
  "wdo-registration-overview": {
    "title": "نظرة عاملة على تسجيلات المراقبة",
    "weekly-registrations": "تسجيلات المراقبة الأسبوعية",
    "daily-registrations": "تسجيلات المراقبة اليومية",
    "columns": {
      "weeknr": "الأسبوع",
      "date": "التاريخ"
    },
    "no-observations-found": {
      "title": "لا يوجد ملاحظات",
      "message": "لم يتم ادخال سجلات المراقبة اليومية و الأسبوعية لهذه الدورة"
    }
  },
  "chicks": "الكتاكيت",
  "cycles": "الدورات",
  "dashboard": "لوحة التحكم",
  "date": "التاريخ",
  "date-of-arrival": "تاريخ الوصول",
  "day-old-chicks": "الكتاكيت",
  "days": "الأيام",
  "decontamination": "إزالة التلوث",
  "delete": "حذف",
  "delete-item-balance": "هل تريد حذف صف الموازنة هذا ؟",
  "delete-item-barn-item": "هل تريد حذف هذه الحظيرة ؟",
  "delete-item-day-old-chick": "هل تريد حذف الكتاكيت ؟",
  "delete-item-departure": "هل تريد حذف المغادرة ؟",
  "delete-item-flock-cycle": "هل تريد حذف دورة القطيع ؟",
  "delivery": {
    "deliveries": "الطلبيات",
    "delivery": "الإستلام"
  },
  "delivery-item": {
    "amount": "الكمية لكل مزرعة",
    "delivery-date": "تاريخ الإستلام",
    "error-amount": "قم بإدخال الكمية",
    "error-delivery-date": "قم بإدخال تاريخ الإستلام",
    "error-no-amount": "قم بإدخال الكمية لحظيرة واحدة على الأقل",
    "error-price": "قم بإدخال صافي التكلفة",
    "error-product-title": "قم بإدخال وصف المنتج",
    "error-supplier-name": "قم بإدخال إسم المزود",
    "error-units-delivered": "قم بإدخال الوحدات المستلمة",
    "error-units-delivered-not-enough": "جزء من هذه الطلبية قد تم إستخدامه بالفعل في موازنة الدورات. لذلك فأنت بحاجة الى ما لا يقل عن :",
    "error-vat": "قم بإدخال نسبة ضريبة القيمة المضافة",
    "external-product-id": "الرقم المرجعي للمنتج",
    "manual-delivery": "إستلام يدوي",
    "price": "صافي التكلفة (دون ضريبة )",
    "product-title": "وصف المنتج",
    "product-type-multiple": "منتج ممزوج",
    "supplier-name": "إسم المزود",
    "units-delivered": "الوحدات المستلمة",
    "vat": "ضريبة القيمة المضافة",
    "price-per-100kg": "السعر الصافي لكل 100 كيلو جرام (دون ضريبة )",
    "error-price-per-100kg": "أدخل السعر الصافي لكل 100 كجم",
    "barn": "إسطبل",
    "invoice-date": "تاريخ الفاتورة",
    "invoice-number": "رقم الفاتورة",
    "vat-percentage": "نسبة ضريبة القيمة المضافة"
  },
  "delivery-overview": {
    "active": "فعال",
    "delivery": "إستلام",
    "delivery-lines": "خطوط الإستلام",
    "display-in-cycle": "عرض في دورة",
    "no-deactivation": {
      "description": "يوجد دورة يتم إستخدام هذه الطلبية فيها",
      "title": "التعطيل غير متاح"
    },
    "no-deliveries": {
      "description": "الطلبيات تضاف بشكل أوتوماتيكي و سوف تظهر هنا",
      "title": "لا يوجد طلبيات خلال الفترة المحددة"
    },
    "remaining-of": "المتبقي من",
    "remove-delivery-warning": {
      "text": "هذا سوف يؤدي الى حذف الطلبية من قائمتك . الطلبيات التي تم إستخدامها في الموازنات لا يمكن حذفها",
      "title": "هل أنت متأكد انك تريد حذف هذه الطلبية"
    },
    "table": {
      "deliveryDate": "تاريخ التسليم او الوصول",
      "deliveryId": "معرف التسليم",
      "product": "المنتوج",
      "isActive": "نشيط",
      "showInFinalSetup": "تظهر في الإعداد النهائي",
      "invoiceDate": "تاريخ الفاتورة",
      "invoiceNumber": "رقم الفاتورة"
    }
  },
  "departure": {
    "barn": "الحظيرة",
    "empty-day-old-chicks-description": "قم بإضافة طلبية و سوف تظهر هنا",
    "empty-day-old-chicks-title": "لا يوجد طلبيات",
    "empty-description": "قم بإضافة مغادرة و سوف تظهر هنا",
    "empty-title": "لا يوجد مغادرات"
  },
  "departure-date": "تاريخ المغادرة",
  "departure-item": {
    "age": "العمر",
    "amount-of-chicks": "العدد",
    "average-weight": "معدل وزن الذبح",
    "barn": "الحظيرة",
    "chicks": "الكتاكيت",
    "date": "التاريخ",
    "error-amount-of-chicks-max": "الحد الأقصى من الكتاكيت هو",
    "error-amount-of-chicks-min": "قم بإضافة كتكوت واحد على الأقل",
    "error-amount-of-chicks-required": "قم بإدخال عدد الكتاكيت",
    "error-barn": "إختر الحظيرة",
    "error-date": "أدخل تاريخ المغادرة. يجب أن يكون هذا بعد أقرب تاريخ وصول ، ولكن ليس في المستقبل.",
    "error-no-chicks-remaining": "لم يتبقى كتاكيت للمغادرة",
    "error-type": "قم بإدخال نوع المغادرة",
    "footpad-lesion-score": "درجة آفة وسادة القدم",
    "footpad-lesion-none": "درجة صفر",
    "footpad-lesion-moderate": "درجة واحدة",
    "footpad-lesion-severe": "درجتان",
    "footpad-lesion-validation": "يجب ان يصل مجموع النسب المئوية في الدرجات 0, 1 و 2 الى 100% بالضبط",
    "heel-dermatitis": "إلتهاب جلد الكعب",
    "revenue": "إجمالي الإيرادات (باستثناء ضريبة القيمة المضافة)",
    "slaughter-results": "نتائج المسلخ (المجزر)",
    "slaughter-weight": "مجموع أوزان الذبح",
    "rejection-at-slaughterhouse": "المرفوض في المسلخ",
    "rejection-during-transport": "المرفوض خلال النقل",
    "slaughterhouse": "المسلخ",
    "type": "النوع",
    "type-full": "تخلص كامل",
    "type-partial": "تخلص جزئي",
    "weight": "الوزن عند المغادرة",
    "weight-validation": "لا يمكن أن يكون الوزن الإجمالي للذبح أكبر من وزن المغادرة.",
    "diverseCosts": "تكاليف متنوعة",
    "revenueSubTotal": "الإيرادات (دون الضريبة )"
  },
  "departure-title": "المغادرة",
  "departure-type-full": "كاملة",
  "departure-type-partial": "جزئية",
  "download-pdf": "تحميل PDF",
  "edit": "تعديل",
  "electricity": "الكهرباء",
  "error-amount-of-chickens": "قم بإدخال عدد الدجاج",
  "error-amount-of-chicks": "قم بإدخل عدد الكتاكيت",
  "error-amount-of-chicks-too-big": "عدد الكتاكيت مرتفع جداً",
  "error-arrival-date": "قم بإدخال تاريخ الوصول",
  "error-barn-selected": "إختر الحظيرة",
  "error-breed": "إختر السلالة",
  "error-chick-birth-date": "قم بإدخال تاريخ الولادة",
  "error-chick-price": "قم بإدخال تكلفة الكتكوت الواحد",
  "error-concept": "قم بإختيار نوعية التربية",
  "error-cycle-number": "قم بإدخال رقم دورة مختلف",
  "error-hatchery": "إختر الفقاسة",
  "error-start-date": "قم بإدخل تاريخ البدء",
  "error-surface-area": "قم بإدخال مساحة السطح",
  "error-total-costs": "قم بإدخال إجمالي التكاليف",
  "error-total-price": "قم بإدخال الكمية",
  "feed": "العلف",
  "flocks": "القطعان",
  "general": "عام",
  "grams": "جرامات",
  "hatchery": "الفقاسة",
  "healthcare": "الرعاية الصحية",
  "heating": "التدفئة",
  "litter": "الأرضية",
  "management": "الإدارة",
  "manure": "الروث",
  "no-barns-description": "قم بإضافة حظيرة و سوف تظهر هنا",
  "no-barns-title": "لا يوجد حظائر",
  "no-cycle-selected-description": "إختر دورة لكي تستطيع رؤية المعلومات حولها",
  "no-cycle-selected-title": "لم يتم إختيار دورة",
  "no-cycles-description": "قم بإضافة دورة و سوف تظهر هنا",
  "no-cycles-title": "لا يوجد دورات",
  "no-day-old-chicks-description": "قم بإضافة طلبية و سوف تظهر هنا",
  "no-day-old-chicks-title": "لا يوجد طلبيات",
  "no-departures-description": "قم بإضافة مغادرة و سوف تظهر هنا",
  "no-departures-title": "لا يوجد مغادرات",
  "none": "لا أحد",
  "nr": "رقم",
  "number-of-day-old-chicks": "الكمية",
  "other": "أمر آخر",
  "print": "طباعة",
  "remove-cycle": "إزالة دورة",
  "report-navigation": {
    "barn-report": "نظرة عامة على الحظيرة"
  },
  "report-overview": {
    "barn": "الحظيرة",
    "barn-report": "نظرة عامة على الحظيرة",
    "barn-report-loading": "جاري إنشاؤه ...",
    "cycle": "الدورة",
    "reports": "التقارير",
    "cycle-closed": "(الدورة منتهية)"
  },
  "save-as-concept": "حفظ نوعية تربية جديدة",
  "settings": "الإعدادات",
  "settings-navigation": {
    "barns": "الحظيرة",
    "observationsetting": "الملاحظات",
    "rvssetting": "أوراق القيم المرجعية",
    "farmresultsetting": "FarmResult",
    "performance": "أداء",
    "finalsetupsetting": "الإعداد النهائي",
    "discountsetting": "خصومات",
    "sustainabilitysetting": "الاستدامة"
  },
  "observations-setting": {
    "description": "هل ترغب في تتبع أداء الدورة على أساس أسبوعي و يومي",
    "switch": "تنشيط الملاحظات اليومية/ الأسبوعية"
  },
  "column-setting": {
    "title": "إعدادات العمود",
    "description": "الأعمدة"
  },
  "rvs-setting": {
    "title": "إعدادات أوراق القيمة المرجعية",
    "temperatureInside-option": {
      "label": "درجة الحرارة",
      "Celcius": "سيليسيوس",
      "Fahrenheit": "فهرنهايت",
      "short": {
        "Celcius": "سيليسيوس",
        "Fahrenheit": "فهرنهايت"
      }
    },
    "feedIntake-option": {
      "label": "العلف",
      "Gram": "جرام",
      "Kilogram": "كيلو جرام",
      "short": {
        "Gram": "جرام",
        "Kilogram": "كيلو جرام"
      }
    },
    "waterIntake-option": {
      "label": "المياه",
      "ML": "ملي لتر",
      "DL": "ديسي لتر",
      "L": "لتر",
      "short": {
        "ML": "ملي لتر",
        "DL": "ديسي لتر",
        "L": "لتر"
      }
    },
    "weight-option": {
      "label": "الوزن",
      "Gram": "جرام",
      "Kilogram": "كيلو جرام",
      "short": {
        "Gram": "جرام",
        "Kilogram": "كيلو جرام"
      }
    },
    "dayoffset": {
      "title": "إعداد يوم البدء",
      "label": "يوم البدء"
    }
  },
  "specify-costs": "تحديد التكاليف",
  "start-date": "تاريخ البدء",
  "title": "PoultryNEXT",
  "title_Agrifirm": "PoultryNEXT",
  "title_Agravis": "Avidata broiler",
  "total-costs": "إجمالي التكاليف",
  "total-price": "القيمة (دون الضريبة )",
  "unspecified-costs": "تكاليف غير محددة",
  "water": "المياه",
  "water-additives": "الإضافات المائية",
  "weeks": "الأسابيع",
  "search": "بحث",
  "dateFrom": "من",
  "dateTo": "إلى",
  "days-of-week": {
    "Monday": "الإثنين",
    "Tuesday": "الثلاثاء",
    "Wednesday": "الأربعاء",
    "Thursday": "الخميس",
    "Friday": "الجمعة",
    "Saturday": "السبت",
    "Sunday": "الأحد"
  },
  "unitOfMeasure": {
    "g/day": "جرام / يوم",
    "€/m²/day": "يورو / متر مربع / يوم",
    "$/m²/day": "دولار / متر مربع / يوم",
    "£/m²/day": "جنيه إسترليني / متر مربع / يوم",
    "zł/m²/day": "ذل / متر مربع / يوم",
    "Ft/m²/day": "قدم / متر مربع / يوم"
  },
  "feed-advice": {
    "overview": {
      "title": "نظرة عامة على النصيحة التغذوية",
      "empty": {
        "title": "النصائح التغذوية غير متاحة",
        "description": "لا يوجد نصائح تغذوية متاحة في هذه اللحظة"
      },
      "table-header": {
        "name": "الإسم",
        "created": "لقد تم إنشاؤه",
        "updated": "لقد تم تحديثه",
        "updatedAdvisorName": "لقد تم تحديثه من قبل",
        "isActive": "فعال"
      },
      "buttons": {
        "add": "قم بإنشاء نصيحة تغذوية",
        "edit": "تعديل",
        "delete": "حذف"
      }
    },
    "create-from-reference": {
      "title": "قم بإنشاء نصيحة تغذوية",
      "scratch-title": "البدء من الصفر",
      "scratch-option-title": "قم بإنشاء نصيحة تغذوية",
      "scratch-button": "البدء من الصفر",
      "scratch-option-subtitle": "نصيحة تغذوية فارغة",
      "reference-schemes-title": "قم بإختيار نصيحة تغذوية مرجعية ك أساس",
      "reference-schemes-button": "البدء مع",
      "product": "المنتج",
      "products": "منتجات",
      "additive": "مادة مضافة",
      "additives": "إضافات"
    },
    "dialog": {
      "deleteConfirm": "هل أنت متأكد انك تريد حذف هذه النصيحة التغذوية",
      "deleteConfirmWhenInUse": "هذه النصيحة الغذائية مرتبطة بدورة , هل أنت متأكد من أنك تريد حذف هذه النصيحة الغذائية ؟"
    },
    "create": {
      "print": "طباعة",
      "title": "نصيحة تغذوية",
      "name": "إسم النصيحة التغذوية",
      "error-name": "يجب إختيار إسم لهذه النصيحة التغذوية",
      "description": "وصف",
      "description-placeholder": "وصف النصيحة التغذوية",
      "product-placeholder": "إختيار منتج",
      "add-product": "إضافة منتج",
      "table-header": {
        "productName": "المنتج",
        "chickenWeightInGrams": "وزن الكتكوت (جرام)",
        "ageFrom": "العمر من (أيام)",
        "ageTo": "العمر إلى (أيام)",
        "totalFeed": "إستهلاك العلف (جرام)",
        "coreFeed": "العلف الأساسي (جرام)",
        "wheatFeed": "القمح (جرام)",
        "comment": "التعليقات",
        "age": "العمر (أيام)",
        "coreFeedTons": "العلف الاساسي (طن)",
        "wheatFeedTons": "القمح (طن)",
        "dosage": "الجرعة (كجم / طن)",
        "applicationMoment": "تطبيق العمر"
      },
      "created": "لقد تم إنشاؤه",
      "updated": "لقد تم تحديثه",
      "number-of-day-old-chicks": "عدد الكتاكيت بعمر يوم واحد",
      "validation-error": {
        "title": "أخطاء التحقق من الصحة",
        "feedadvice-name": "مطلوب اسم نصيحة التغذية",
        "age-from": "العمر من مطلوب",
        "chicken-weight": "مطلوب وزن الدجاج",
        "product": "المنتج مطلوب",
        "total-feed": "إجمالي العلف مطلوب",
        "age-to": "العمر المطلوب (باستثناء السطر الأخير)",
        "age-min-max": "يجب أن يكون \"العمر من\" أقل من \"Age To\""
      },
      "products": "نصائح التغذية الأساسية",
      "additives": "الاضافات",
      "show-additives": "تظهر الاضافات",
      "add-additive": "أضف إضافة"
    },
    "print": {
      "farmcompany": "شركة",
      "customernr": "رقم العميل",
      "contactperson": "الشخص الذي يمكن الإتصال به",
      "location": "الموقع",
      "customerservice": "خدمة العملاء",
      "table-header": {
        "productName": "المنتج",
        "chickenWeightInGrams": "وزن الكتكوت",
        "age": "العمر",
        "totalFeed": "إستهلاك العلف",
        "coreFeed": "الأساسي",
        "wheatFeed": "القمح",
        "comment": "التعليقات",
        "gramPerChick": "غرام / كتكوت",
        "orderQuantity": "كمية الطلبية (طن)",
        "units_gram": "(جرام)",
        "units_days": "(أيام)",
        "dosage": "الجرعة",
        "units_kgton": "كجم / طن",
        "applicationMoment": "لحظة التطبيق"
      }
    }
  },
  "standard-reference-value-sheet": {
    "overview": {
      "title": "نظرة عامة على أوراق القيم المرجعية القياسية"
    },
    "create": {
      "title": "ورقة القيمة المرجعية القياسية"
    }
  },
  "reference-value-sheet": {
    "overview": {
      "title": "نظرة عامة على أوراق القيم المرجعية",
      "empty": {
        "title": "معلومات ورقة القيمة المرجعية غير متاحة",
        "description": "لا يوجد معلومات ورقة قيمة مرجعية متاحة في هذه اللحظة"
      },
      "table-header": {
        "name": "الإسم",
        "created": "لقم تم إنشاؤه",
        "updated": "لقد تم تحديثه",
        "updatedAdvisorName": "لقد تم تحديثه من قبل",
        "isActive": "فعال"
      },
      "buttons": {
        "add": "قم بإضافة ورقة قيمة مرجعية",
        "edit": "تعديل",
        "delete": "حذف",
        "copy-as-new": "نسخ كجديد",
        "copy-to-other-country": "نسخ إلى بلد آخر"
      },
      "country": "البلد"
    },
    "dialog": {
      "deleteConfirm": "هل أنت متأكد من أنك تريد حذف ورقة القيمة المرجعية هذه ؟",
      "deleteConfirmWhenInUse": "ورقة القيمة المرجعية هذه مرتبطة بدورة ، هل أنت متأكد من أنك تريد حذف ورقة القيمة المرجعية هذه؟"
    },
    "create-from-standard": {
      "title": "قم بإنشاء ورقة قيمة مرجعية",
      "scratch-title": "البدء من الصفر",
      "scratch-option-title": "البدء بورقة القيمة المرجعية",
      "scratch-button": "البدء من الصفر",
      "scratch-option-subtitle": "ورقة القيمة المرجعية فارغة",
      "reference-value-sheet-title": "قم بإختيار ورقة قيمة مرجعية كأساس",
      "reference-value-sheet-button": "البدء مع"
    },
    "create": {
      "print": "طباعة",
      "title": "ورقة قيمة مرجعية",
      "name": "إسم ورقة القيمة المرجعية",
      "error-name": "يجب إختيار إسم لورقة القيمة المرجعية",
      "add-one-day-values-row": "أضف يوم",
      "number-of-days": "الأيام",
      "add-multiple-day-values-rows": "أضف الأيام",
      "description": "وصف",
      "description-placeholder": "وصف ورقة القيمة المرجعية",
      "no-day-values-title": "ورقة القيمة المرجعية فارغة",
      "no-day-values-description": "قم بإضافة الأيام إلى ورقة القيمة المرجعية في الأسفل للقيام بالبدء",
      "table-header": {
        "day": "يوم",
        "temperatureInside": "درجة الحرارة الداخلية",
        "relativeHumidity": "الرطوبة النسبية (%)",
        "feedIntake": "إستهلاك العلف",
        "feedIntakePerChickPerDay": "إستهلاك العلف",
        "feedIntakeTotal": "مجموع إستهلاك العلف",
        "feedIntakePerChickTotal": "مجموع إستهلاك العلف",
        "waterIntake": "المياه",
        "weight": "الوزن",
        "mortality": "النفوق",
        "feedConversion": "مجموع التحويل الغذائي",
        "waterToFeedRatio": "نسبة المياه إلى العلف"
      },
      "created": "لقد تم إنشاؤه",
      "updated": "لقد تم تحديثه",
      "validation-error": {
        "title": "أخطاء التحقق من الصحة",
        "refvalsheet-name": "اسم ورقة القيمة المرجعية مطلوب"
      }
    },
    "print": {
      "farmcompany": "شركة",
      "customernr": "رقم العميل",
      "contactperson": "الشخص الذي يمكن الإتصال به",
      "location": "الموقع"
    },
    "select-country": {
      "title": "اختر الدولة",
      "description": "حدد الدولة التي تريد نسخها إليها",
      "label": "دولة"
    }
  },
  "reference-scheme": {
    "overview": {
      "title": "نظرة عامة على النصيحة التغذوية المرجعية",
      "empty": {
        "title": "لا يوجد نصائح تغذوية مرجعية متاحة",
        "description": "لا يوجد نصائح تغذوية مرجعية متاحة في هذه اللحظة"
      },
      "table-header": {
        "name": "الإسم",
        "created": "لقد تم إنشاؤه",
        "updated": "لقد تم تحديثه",
        "updatedAdvisorName": "لقد تم تحديثه من قبل",
        "isActive": "فعال"
      },
      "buttons": {
        "add": "قم بإنشاء نصيحة تغذوية مرجعية",
        "edit": "تعديل",
        "delete": "حذف"
      },
      "country": "البلد"
    },
    "dialog": {
      "deleteConfirm": "هل أنت متأكد من أنك تريد حذف النصيحة التغذوية المرجعية ؟"
    },
    "create": {
      "title": "نصيحة تغذوية مرجعية",
      "name": "إسم النصيحة التغذوية المرجعية",
      "error-name": "يجب إختيار إسم للنصيحة التغذوية المرجعية",
      "description": "وصف",
      "description-placeholder": "وصف النصيحة التغذوية المرجعية",
      "product-placeholder": "إختيار منتج",
      "add-product": "إضافة منتج",
      "table-header": {
        "productName": "المنتج",
        "chickenWeightInGrams": "وزن الكتكوت (جرام)",
        "ageFrom": "العمر من (أيام)",
        "ageTo": "العمر الى (أيام)",
        "totalFeed": "إستهلاك العلف (جرام)",
        "coreFeed": "العلف الأساسي (جرام)",
        "wheatFeed": "القمح (جرام)",
        "comment": "التعليقات"
      },
      "created": "لقد تم إنشاؤه",
      "updated": "لقد تم تحديثه"
    }
  },
  "product-title": "المنتجات",
  "product-save": "حفظ المنتج",
  "product-saved": "لقد تم حفظ المنتج",
  "product-overview": {
    "title": "نظرة عامة على المنتج",
    "overview": {
      "productName": "الإسم",
      "productCode": "رمز المنتج",
      "phase": "المراحل",
      "isActive": "فعال",
      "productType-Feed": "تغذية",
      "productType-Additive": "مادة مضافة",
      "productType": "نوع المنتج"
    },
    "no-products": {
      "title": "لا يوجد منتجات",
      "description": "يمكن إنشاء المنتج من خلال النقر على إضافة منتج"
    },
    "delete-confirmation-title": "حذف المنتج",
    "delete-confirmation-message": "هل أنت متأكد من أنك تريد حذف هذا المنتج",
    "delete-error-message": "لم نتمكن من إزالة المنتج. تأكد من عدم إستخدام المنتج في مخطط مرجعي",
    "delete-error-in-use-message": "لا يمكن إزالة هذا المنتج, لإنه قيد الإستخدام في نصيحة تغذوية واحدة أو أكثر",
    "country": "البلد",
    "delete-confirmation-message-when-in-use": "يُستخدم هذا المنتج في إشعار موجز واحد أو أكثر ، هل أنت متأكد من أنك تريد إزالة هذا المنتج؟"
  },
  "create-product": {
    "title-create": "منتج جديد",
    "title-edit": "تعديل المنتج",
    "product-name": "إسم المنتج",
    "phases-label": "المراحل",
    "product-code": "رمز المنتج",
    "error-product-name": "يرجى إدخال إسم المنتج",
    "error-product-code": "يرجى إدخال رمز المنتج",
    "error-code-name-already-in-use": "الرجاء استخدام تركيبة فريدة من الاسم والرمز.",
    "product-type": {
      "label": "نوع المنتج",
      "Feed": "تغذية",
      "Additive": "مادة مضافة"
    },
    "error-product-type": "نوع المنتج مطلوب."
  },
  "countries": {
    "BE": "بلجيكا",
    "DE": "المانيا",
    "HU": "هنغاريا",
    "NL": "هولندا",
    "PL": "بولندا",
    "JO": "الأردن",
    "NG": "نيجيريا",
    "JM": "جامايكا",
    "TZ": "تنزانيا",
    "DA": "ألمانيا-أغرافيس"
  },
  "save": "حفظ",
  "report-title": "نظرة عامة على حظيرة الدواجن",
  "report-name": "تقرير القطيع",
  "report-headers": {
    "general": "عام",
    "day-old-chicks": "الكتاكيت",
    "total": "المجموع",
    "departures": "المغادرات",
    "balance": "الرصيد",
    "key-figures": "االنتائج الرئيسية",
    "technical": "فني",
    "financial": "مالي"
  },
  "report-columns": {
    "customer": "عميل",
    "location": "الموقع",
    "barn": "الحظيرة",
    "breed": "السلالة",
    "concept": "الفكرة",
    "start-date": "تاريخ البدء",
    "date": "التاريخ",
    "age": "العمر (أيام)",
    "amount": "الكمية",
    "price": "السعر (دون الضريبة)",
    "discount": "الخصم (دون الضريبة)",
    "delivered": "الكمية المستلمة (كيلو جرام)",
    "weight": "وزن (جرام)",
    "paid": "المدفوع (كيلو جرام)",
    "rejected": "مرفوض (%)",
    "feed-code": "رمز العلف",
    "feed-name": "إسم العلف",
    "consumption": "الإستهلاك (كيلو جرام)",
    "consumption-per-day-old-chick": "الإستهلاك لكل كتكوت (جرام)",
    "day-old-chicks": "كتكوت لكل متر مربع",
    "drop-out-total": "إجمالي المرفوض في المسلخ %",
    "avg-age": "متوسط العمر (أيام)",
    "avg-weight": "متوسط الوزن (جرام)",
    "deliveredkg-per-m2": "الوزن بالكيلو جرام لكل مترمربع",
    "growth": "نمو",
    "feed-conversion": "التحويل الغذائي",
    "feed-conversion-1500": "التحويل الغذائي 1500",
    "replacement": "نسبة الإستبدال",
    "avg-rejected": "متوسط نسبة الرفض",
    "production-number": "الرقم الانتاجي",
    "price-per-delivered-chick": "التكلفة لكل كتكوت",
    "feed-price-per-100": "تكلفة العلف لكل 100كيلوجرام",
    "feed-price-per-delivered-kg": "تكلفة العلف لكل كيلوغرام",
    "yield-per-kg": "العائد لكل كيلو جرام",
    "feed-profit": "العلف",
    "feed-profit-per-day-old-chick": "عائد العلف لكل كتكوت",
    "feed-profit-per-m2-per-day": "عائد العلف لكل متر مربع في اليوم",
    "cycle-nr": "رقم الدورة",
    "barns": "الحظائر",
    "netto-profit-incl-other-costs": "صافي الربح شامل التكاليف الأخرى",
    "discountLabel-ledenvoordeel": "مزايا العضوية",
    "discountLabel-ledenkorting": "التخفيض الخاص بالأعضاء",
    "discountLabel-integratiepremie": "علاوة التكامل",
    "discountLabel-nieuwbouwpremie": "قسط البناء الجديد",
    "discountLabel-ncw": "توزيع صافي القيمة الحالية",
    "total-incl-discount": "الإجمالي (شاملاً التخفيضات)",
    "discountLabel-korting": "خصم",
    "discountLabel-overig": "أخرى",
    "discountLabel-nabetaling": "الدفع الخلفي",
    "discountLabel-correctievoerprijs": "تصحيح تغذية التصحيح",
    "discountLabel-vergoedingvolgensafspraak": "التعويضات حسب الاتفاقية",
    "feed-profit-per-m2": "ربح العلف لكل متر مربع (طن متري)"
  },
  "total": "المجموع",
  "days-short": "الأيام",
  "parent-stock-identifier": "معرف قطيع الأمهات",
  "import": "يستورد",
  "csv-import": {
    "delivery-success": "تم استيراد التوريدات بنجاح.",
    "departure-success": "تم استيراد المغادرات بنجاح.",
    "errors": {
      "amount-exceeds-remaining": "الصف ${rowNumber}: الكمية تتجاوز عدد الكتاكيت المتبقية للحظيرة '${barn}'. الحد الأقصى المسموح به هو ${maxAmount}.",
      "barn-not-found": "الصف ${rowNumber}: لم يتم العثور على الحظيرة '${value}' في الدورة المحددة.",
      "configured-slaughterhouses-could-not-be-loaded": "تعذر تحميل المسالخ المكوّنة.",
      "cycle-could-not-be-loaded": "تعذر تحميل الدورة '${cycleId}'.",
      "cycle-invalid": "مغادرات CSV غير صالحة للدورة المحددة.",
      "cycle-not-found": "لم يتم العثور على الدورة '${cycleId}' للعميل/الموقع الحالي.",
      "date-before-first-arrival": "الصف ${rowNumber}: يجب أن يكون التاريخ في تاريخ أول وصول أو بعده.",
      "date-in-future": "الصف ${rowNumber}: لا يمكن أن يكون التاريخ في المستقبل.",
      "duplicate-column": "يحتوي ملف CSV على العمود المكرر '${column}'.",
      "file-empty": "ملف CSV فارغ.",
      "file-required": "ملف CSV مطلوب.",
      "file-too-large": "ملف CSV كبير جدًا. الحد الأقصى للحجم المسموح به هو ${maxSizeKb} كيلوبايت.",
      "invalid-date": "الصف ${rowNumber}: ${field} مطلوب ويجب أن يكون تاريخًا صالحًا.",
      "invalid-number": "الصف ${rowNumber}: يجب أن يكون ${field} رقمًا صالحًا.",
      "missing-required-columns": "يفتقد ملف CSV إلى عمود/أعمدة مطلوبة: ${columns}.",
      "no-data-rows": "يجب أن يحتوي ملف CSV على صف بيانات واحد على الأقل.",
      "required-field": "الصف ${rowNumber}: ${field} مطلوب.",
      "required-positive-whole-number": "الصف ${rowNumber}: ${field} مطلوب ويجب أن يكون عددًا صحيحًا موجبًا.",
      "required-valid-number": "الصف ${rowNumber}: ${field} مطلوب ويجب أن يكون رقمًا صالحًا.",
      "skip-import-invalid": "الصف ${rowNumber}: يجب أن يكون تخطي الاستيراد فارغًا أو إحدى القيم التالية: yes, no, true, false, 1, 0, x.",
      "slaughterhouse-not-found": "الصف ${rowNumber}: لم يتم العثور على المسلخ '${value}'.",
      "too-many-rows": "يحتوي ملف CSV على عدد كبير جدًا من الصفوف. الحد الأقصى المسموح به للصفوف هو ${maxRows}.",
      "total-slaughterweight-higher-than-departure-weight": "الصف ${rowNumber}: لا يمكن أن يكون إجمالي وزن الذبح أعلى من وزن المغادرة.",
      "type-invalid": "الصف ${rowNumber}: النوع مطلوب ويجب أن يكون كاملاً أو جزئيًا.",
      "unterminated-quote": "يحتوي ملف CSV على قيمة بها علامة اقتباس افتتاحية بدون علامة اقتباس إغلاق.",
      "unknown": "فشل استيراد CSV.",
      "unsupported-file-type": "يتم دعم ملفات CSV فقط."
    },
    "download-template": "تنزيل القالب",
    "invalid-file": "حدد ملف CSV صالحًا.",
    "upload": "تحميل CSV"
  },
  "slaughter-report": "تقرير الذبح",
  "link-slaughter-results-title": "ربط نتائج الذبح",
  "link-slaughter-results-description": "قم بإختيار حظيرة واحدة لكل تقرير ذبح. لكل تقرير ذبح، سيتم إنشاء صف مغادرة واحد.",
  "slaughter-date": "تاريخ الذبح",
  "number-of-chickens": "عدد الدجاج",
  "departure-weight-kg": "وزن المغادرة (كيلو جرام)",
  "show-financial-data": "إظهار البيانات المالية",
  "financial-results": "النتائج المالية",
  "link-to-barn": "ربط إلى الحظيرة",
  "imported-slaughter-report-label": "تقرير ذبح مستورد",
  "slaughter-weight-kg": "وزن الذبح (كيلو جرام)",
  "veterinary": "طبيب بيطري",
  "employment": "موظف",
  "otherRevenue": "مصدر دخل آخر",
  "otherCosts": "التكاليف الأخرى",
  "discount-title": "الخصومات",
  "discount-label": "بطاقة التخفيض",
  "discount-applicabilityType": "ينطبق على",
  "discount-amount": "المبلغ, بإستثناء. ضريبة القيمة المضافة",
  "discount-item": {
    "applicabilityType-arrivalcost": "تكاليف الوصول",
    "applicabilityType-feedcost": "تكاليف العلف",
    "applicabilityType-departurerevenue": "إيرادات المغادرة",
    "add-discount": "أضف تخفيض",
    "labelType-ledenvoordeel": "مزايا العضوية",
    "labelType-ledenkorting": "التخفيض الخاص بالأعضاء",
    "labelType-integratiepremie": "علاوة التكامل",
    "labelType-nieuwbouwpremie": "قسط البناء الجديد",
    "labelType-ncw": "توزيع صافي القيمة الحالية",
    "labelType-korting": "خصم",
    "labelType-overig": "أخرى",
    "labelType-nabetaling": "الدفع الخلفي",
    "labelType-correctievoerprijs": "تصحيح تغذية التصحيح",
    "labelType-vergoedingvolgensafspraak": "التعويضات حسب الاتفاقية"
  },
  "discount": {
    "no-discounts-title": "لا توجد خصومات بعد.",
    "no-discounts-description": "أضف خصمًا وسيظهر هنا."
  },
  "delete-item-discount": "هل تريد إزالة التخفيض؟",
  "farm-result": {
    "table-header": {
      "sensorActuator": "معرف جهاز الاستشعار / المشغل",
      "barn": "إسطبل",
      "sensorActuatorName": "اسم المستشعر / المشغل",
      "farmResultLocationId": "معرف الموقع"
    },
    "select-barn-placeholder": " - حدد حظيرة - "
  },
  "discountLabel-korting": "خصم",
  "discountLabel-overig": "أخرى",
  "discountLabel-nabetaling": "الدفع الخلفي",
  "discountLabel-correctievoerprijs": "تصحيح تغذية التصحيح",
  "discountLabel-vergoedingvolgensafspraak": "التعويضات حسب الاتفاقية",
  "delete-item-day-old-chick-used-in-balance": "يتم استخدام هذا التسليم حاليًا في الميزان. إذا اخترت حذف هذا التسليم ، فيجب إعادة حساب الرصيد. هل تريد حذف التسليم؟",
  "edit-day-old-chick_barn-used-in-balance": "أنت تقوم بتغيير حظيرة يتم استخدامها في الميزان. إذا قمت بحفظ هذا التغيير ، فيجب إعادة حساب الرصيد. هل تريد الاستمرار؟",
  "cycle-description": "وصف",
  "confirm": "إرسال",
  "interval-type-Day": "يوم",
  "interval-type-Week": "أسبوع",
  "unitOfMeasure-setting": {
    "title": "وحدة القياس",
    "warning": "يمكن أن يؤدي تغيير إعدادات وحدة القياس إلى اختلافات صغيرة في القيمة ناتجة عن التقريب الرياضي.",
    "waterIntakeUnit": "وحدة سحب المياه",
    "CumulativeLiter": "لتر تراكمي",
    "MililiterPerBird": "مليلتر لكل طائر",
    "feedIntakeUnit": "وحدة تناول العلف",
    "CumulativeKilogram": "كيلوغرام تراكمي",
    "GramPerBird": "غرام لكل طائر"
  },
  "error-amount-of-chicks-minimum": "الحد الأدنى من الكتاكيت هو:",
  "animal-group": {
    "animalGroupTitle": "Animal Group",
    "switchDay": "يوم التبديل",
    "addSwitchDay": "أضف يوم التبديل",
    "phaseFrom": "المرحلة من",
    "phaseTo": "المرحلة إلى",
    "date": "تاريخ",
    "medication": "دواء",
    "treatmentDateStart": "بدء العلاج",
    "treatmentDateEnd": "نهاية العلاج",
    "addMedication": "أضف الدواء",
    "diagnose": "تشخيص",
    "quantity": "الكمية",
    "unit": "الوحدة",
    "quantityUnitDescriptions": {
      "kilogram": "كيلوغرامات",
      "gramsPerLitre": "غرام لكل لتر",
      "percentage": "النسبة المئوية",
      "gram": "غرامات",
      "noUnit": "بدون وحدة",
      "gramsPerKilogram": "غرام لكل كيلوغرام",
      "milligram": "مليغرامات",
      "milligramsPerKilogram": "مليغرام لكل كيلوغرام"
    },
    "vaccination": "تلقيح",
    "addVaccination": "أضف التطعيم",
    "vaccine": "مصل",
    "poultryDisease": "مرض الدواجن",
    "vaccinationMethod": "طريقة التطعيم",
    "validationDialogTitle": "معلومات مطلوبة",
    "validationDialogMessage": "الرجاء إضافة المعلومات المطلوبة في الجداول",
    "veterinarianTitle": "طبيب بيطري"
  },
  "final-setup-setting": {
    "switch": "الإعداد النهائي",
    "chick-delivery-switch": "تسليم الكتاكيت",
    "feed-delivery-switch": "توصيل العلف",
    "departure-switch": "المغادرة",
    "discount-switch": "الخصومات",
    "title": "الإعداد النهائي",
    "default-settings-title": "الإعدادات الافتراضية",
    "masterdata": {
      "title": "البيانات الرئيسية",
      "notes": "ملحوظات",
      "payer": "دافع",
      "payer-email": "البريد الإلكتروني للدافع",
      "representative-agrifirm": "ممثل <Tenant>",
      "separate-stable": "مستقرة منفصلة",
      "integration-premium": "قسط التكامل",
      "discount-value": "قيمة الخصم",
      "agrifirm-member": "عضو في شركة <Tenant>"
    }
  },
  "invoice-date": "تاريخ الفاتورة",
  "invoice-number": "رقم الفاتورة",
  "vat-percentage": "نسبة ضريبة القيمة المضافة",
  "vat": "ضريبة القيمة المضافة (%)",
  "amount-including-vat": "المبلغ شاملاً ضريبة القيمة المضافة (€)",
  "final-setup": {
    "chick-deliveries": "تسليمات الكتاكيت",
    "empty-chick-deliveries-title": "لا تسليمات الكتاكيت",
    "empty-chick-deliveries-description": "لا تسليمات الكتاكيت",
    "day-old-chick": "كتاكيت بعمر يوم واحد",
    "feed-deliveries": "توصيل العلف\n",
    "empty-feed-deliveries-title": "لا يوجد تسليم الأعلاف",
    "empty-feed-deliveries-description": "لا يوجد تسليم الأعلاف",
    "empty-departures-description": "لا المغادرين",
    "departures": "المغادرات",
    "empty-departures-title": "لا المغادرين",
    "discounts": "الخصومات",
    "empty-discounts-title": "لا خصومات",
    "empty-discounts-description": "لا خصومات",
    "print-footer": "تخضع جميع الاتفاقيات المبرمة والمنتجات و/أو الخدمات التي نقدمها حصريًا للشروط والأحكام العامة للتسليم الخاصة بشركة Agrifirm NWE BV. وسيتم إرسالها إليك مجانًا عند الطلب الأول ويمكن أيضًا الرجوع إليها وحفظها عبر: https://www.agrifirm.nl/globalassets/agrifirm-group/agrifirm-nl/leveringsvoorwaarden/general-terms--nl.pdf​",
    "print-footer-agravis": "تخضع جميع الاتفاقيات المبرمة والمنتجات و/أو الخدمات التي نقدمها حصريًا للشروط والأحكام العامة للتسليم الخاصة بـ Agravis. وسيتم إرسالها إليك مجانًا عند الطلب الأول.",
    "print-description": "وصف",
    "print-message-line-1": "عزيزي السيد/السيدة،",
    "print-message-line-2": "سوف نرسل لك نظرة عامة على فواتير الجولة الماضية.",
    "print-end-line-1": "يجب أن تتوافق النظرة العامة المذكورة أعلاه مع إدارتك.",
    "print-end-line-2": "أطيب التحيات،",
    "print-company-name": "Agrifirm NWE BV",
    "print-company-name-agravis": "Agravis",
    "print-company-email": "البريد الإلكتروني: kengetallenadministratie@agrifirm.com",
    "print-company-email-agravis": "البريد الإلكتروني: info@agravis.nl",
    "print-company-phone": "الهاتف: 088 - 488 2976",
    "print-company-phone-agravis": "",
    "print-to-receive": "باستقبالك",
    "print-total-feed": "إجمالي التغذية، انظر المرفق للحصول على المواصفات",
    "print-invoice-number": "رقم الفاتورة.",
    "print-amount-excluding-vat": "المبلغ باستثناء ضريبة القيمة المضافة",
    "print-vat-amount": "قيمة الضريبة",
    "print-amount-including-vat": "المبلغ شامل ضريبة القيمة المضافة",
    "print-product": "منتج",
    "print-net-weight": "صافي كجم",
    "include-in-calculations-label": "تدرج في الحسابات",
    "print-to-pay": "بالدفع لك",
    "print-payment-terms": "نرجو منك دفع المبلغ المذكور أعلاه خلال 14 يومًا، مع ذكر رقم العميل الخاص بك، إلى الحساب البنكي NL.86.RABO.010.10.50.003.",
    "print-subtotal": "المجموع الفرعي",
    "feed-delivery-end-date": "تاريخ انتهاء دورة الإعداد النهائية",
    "additional-invoices": "فواتير إضافية",
    "empty-additional-invoices-title": "لا فواتير إضافية",
    "empty-additional-invoices-description": "لا فواتير إضافية",
    "additional-invoices-add": "أضف الفاتورة",
    "additional-invoices-delete-confirm-title": "إزالة الفاتورة الإضافية",
    "additional-invoices-delete-confirm-description": "هل أنت متأكد أنك تريد إزالة هذه الفاتورة؟",
    "fixed-price": "اتفاقية السعر الثابت",
    "fixed-price-per-100": "السعر لكل 100 كيلو",
    "fixed-price-correction": "تصحيح الأسعار على النحو المتفق عليه",
    "price-agreement": "اتفاقية السعر",
    "per-100-kg": "/ 100 كجم غير شامل ضريبة القيمة المضافة"
  },
  "amount-excluding-vat": "القيمة (بدون الضريبة) (€)",
  "discount-description": "وصف",
  "discount-showInFinalSetup": "تظهر في الإعداد النهائي",
  "label": "ملصق",
  "link-slaughter-invoices-description": "حدد الفواتير التي تريد ربطها بالدورة. لكل فاتورة، سيتم إنشاء صف واحد في الإعداد النهائي.",
  "link-slaughter-invoices-title": "ربط فواتير الذبح",
  "slaughter-invoice": "فاتورة الذبح",
  "vaccination-price": "سعر التطعيم لكل فرخ",
  "discount-price": "سعر التطعيم لكل فرخ",
  "diverse-price": "تكلفة متنوعة لكل كتكوت",
  "total-price-including-vat": "المبلغ، بما في ذلك. ضريبة القيمة المضافة",
  "total-calculated-amount": "المبلغ الإجمالي",
  "total-calculated-amount-including-vat": "المبلغ الإجمالي شاملاً ضريبة القيمة المضافة",
  "arrival-notification-cycle-overview": "يتم تضمين السعر الصافي لكل تطعيم والبنود المتنوعة لكل كتكوت في النظرة المالية العامة، حيث يمكن العثور على الإجمالي",
  "arrival-notification-final-setup": "يتم تضمين السعر الصافي لكل تطعيم والبنود المتنوعة لكل كتكوت في النظرة المالية العامة، حيث يمكن العثور على الإجمالي",
  "edit-day-old-chick": "تعديل الإستلام",
  "edit-departure": "تعديل المغادرة",
  "of-delivery": "الإستلام",
  "delivery-date": "تاريخ الإستلام",
  "delivery-number": "معرف التسليم",
  "base-quantity": "الكمية (كيلو جرام)",
  "discount-setting": {
    "title": "خصومات",
    "memberDiscountNL": "خصم الأعضاء (€)",
    "memberBenefitNL": "استحقاقات الأعضاء (%)",
    "memberBenefitAbroad": "فائدة الأعضاء في الخارج (%)",
    "warning-title": "احذر!",
    "warning-message": "يتم استخدام هذه القيم لجميع العملاء والمواقع. لا تغيرهم."
  },
  "sustainability": {
    "calculations": {
      "source": "المصدر",
      "value": "القيمة",
      "unit": "الوحدة",
      "description": "اعرض الحسابات السابقة أو احسب دورة أخرى.",
      "new": "حساب جديد",
      "result": "نتيجة محفوظة",
      "history": "الحسابات السابقة",
      "last-updated": "آخر تحديث",
      "history-description": "اختر حساباً لعرض نتيجته.",
      "calculation": "الحساب",
      "view-result": "عرض النتيجة",
      "empty": "لا توجد حسابات محفوظة لهذه الدورة بعد.",
      "select-cycle": "اختر دورة لعرض حساباتها المحفوظة.",
      "loading": "جارٍ تحميل الحسابات…",
      "load-error": "تعذر تحميل الحسابات. حاول مرة أخرى.",
      "retry": "حاول مرة أخرى",
      "pending": "لا يزال هذا الحساب قيد المعالجة. حدّث النتيجة لاحقاً.",
      "calculating": "جارٍ استيراد الأعلاف وحساب البصمة الكربونية…",
      "result-failed": "فشل هذا الحساب. تحقق من المتطلبات في لوحة الحساب ثم حاول مرة أخرى. إذا استمر ذلك، تواصل مع مستشارك.",
      "attempt-failed": "فشلت المحاولة الأخيرة. تحقق من المتطلبات أدناه ثم حاول مرة أخرى. تبقى النتائج المحفوظة متاحة.",
      "status": {
        "complete": "تم الحساب",
        "pending": "قيد المعالجة",
        "failed": "فشل"
      }
    },
    "readiness": {
      "view-details": "عرض تفاصيل بيانات العلف",
      "requirements-met": "متطلبات مستوفاة",
      "title": "المتطلبات",
      "checking": "جارٍ التحقق من البيانات المطلوبة…",
      "error": "تعذر التحقق من البيانات المطلوبة. حاول مرة أخرى.",
      "ready": "البيانات المطلوبة مكتملة.",
      "blocked": "أكمل البيانات التالية قبل بدء الحساب.",
      "complete": "مكتمل",
      "action-required": "يلزم اتخاذ إجراء",
      "edit-arrivals": "تعديل الاستقبال",
      "edit-departures": "تعديل المغادرة",
      "edit-resources": "تعديل استهلاك الطاقة السنوي",
      "edit-bedding": "تعديل الفرشة",
      "advisor": "تواصل مع مستشارك لتصحيح هذه البيانات. شارك تفاصيل المنتج والتسليم الموضحة أعلاه.",
      "disclaimer": "يتحقق هذا الفحص من البيانات المطلوبة. قد يرفض Sustell الحساب رغم ذلك.",
      "recheck": "التحقق مجددًا",
      "calculation-failed": "تعذر على Sustell حساب هذه البصمة الكربونية. تحقق من المتطلبات أدناه ثم حاول مرة أخرى. إذا استمرت المشكلة، تواصل مع مستشارك.",
      "requirements": {
        "cycle": "الاستقبال والمغادرة والتواريخ الصحيحة",
        "farm-resources": "الطاقة لكل سنة مطلوبة",
        "bedding": "بيانات الفرشة",
        "feeds": "القيم الغذائية وانبعاثات العلف"
      },
      "arrival-weight": "متوسط وزن الاستقبال لكل طائر",
      "departure-weight": "متوسط وزن المغادرة لكل طائر",
      "issues": {
        "feeds-missing": "سجل استهلاك العلف المركب في ميزان العلف لهذه الدورة.",
        "arrivals-missing": "سجل استقبال الكتاكيت.",
        "departures-missing": "سجل المغادرة.",
        "cycle-dates-invalid": "صحح تواريخ الدورة والاستقبال والمغادرة.",
        "arrival-data-invalid": "أدخل عددًا موجبًا من الطيور ووزن الاستقبال بالغرام لكل طائر.",
        "departure-data-invalid": "أدخل عددًا موجبًا من الطيور والوزن الإجمالي عند المغادرة بالكيلوغرام.",
        "departure-weight-below-arrival": "يجب أن يكون متوسط وزن المغادرة مساويًا لمتوسط وزن الاستقبال على الأقل. تحقق من وزن الاستقبال بالغرام لكل طائر والوزن الإجمالي للمغادرة بالكيلوغرام وأعداد الطيور.",
        "farm-resources-missing": "سجل استهلاك الطاقة للسنة",
        "cycle-dates-required": "سجل استقبالًا ومغادرة بتواريخ صحيحة للتحقق من السنوات المطلوبة.",
        "bedding-type-missing": "اختر نوع الفرشة.",
        "bedding-amount-missing": "أدخل كمية الفرشة.",
        "ship-to-missing": "موقع التسليم غير مرتبط بمورد العلف.",
        "delivery-missing": "بيانات التسليم غير متاحة.",
        "delivery-line-missing": "بيانات المنتج المسلم غير متاحة.",
        "feed-data-invalid": "بيانات العلف المطلوبة مفقودة أو غير صالحة.",
        "feed-settings-missing": "إعدادات استيراد العلف غير مكتملة.",
        "farm-resources-not-calculated": "احفظ بيانات الطاقة مرة أخرى لتخصيص الاستهلاك لهذه الدورة."
      },
      "fields": {
        "Consumption": "استهلاك العلف (كجم)، أكبر من صفر",
        "Co2Total": "البصمة الكربونية الإجمالية",
        "Co2TotalMismatch": "إجمالي CO₂ لا يطابق مجموع الانبعاثات الحيوية والأحفورية وانبعاثات تغيير استخدام الأراضي. اطلب من مستشارك تصحيح بيانات العلف.",
        "Biogenic": "الانبعاثات الحيوية",
        "FossilExcludingPeatEmissions": "الانبعاثات الأحفورية باستثناء الخث",
        "FossilPeatEmissions": "انبعاثات الخث",
        "LandUseChange": "انبعاثات تغير استخدام الأراضي",
        "DryMatterAmount": "محتوى المادة الجافة",
        "RoughProtein": "محتوى البروتين",
        "ProductIdentifier": "رقم المنتج"
      },
      "edit-feeds": "تعديل ميزان العلف",
      "edit-cycle": "تعديل الدورة"
    },
    "sustainability": "الاستدامة",
    "farm-resources": "الطاقة في السنة",
    "carbon-footprint": "البصمة الكربونية",
    "add-farm-resources": "إضافة موارد المزرعة",
    "confirm-delete-farm-resource": "حذف مورد المزرعة؟",
    "farm-resource-deleted": "تم حذف مورد المزرعة",
    "farm-resource-saved": "تم حفظ موارد المزرعة",
    "year": "سنة",
    "farm-settings-saved": "تم حفظ إعدادات المزرعة",
    "farm-settings-enable-co2-calculation": "تمكين حسابات ثاني أكسيد الكربون لهذه المزرعة",
    "resource": {
      "electricity": "الكهرباء (كيلوواط ساعة)",
      "electricity-photovoltaic": "الكهرباء الشمسية (كيلوواط ساعة)",
      "electricity-wind": "الكهرباء الرياح (كيلوواط ساعة)",
      "natural-gas": "الغاز الطبيعي (م³)",
      "diesel": "ديزل (لتر)",
      "gasoline": "البنزين (لتر)",
      "coal": "الفحم (كجم)",
      "propane-lpg": "البروبان / غاز البترول المسال (لتر)",
      "water": "الماء (م³)",
      "cycle-start-date": "تاريخ البدء",
      "cycle-end-date": "تاريخ الانتهاء",
      "status": "حالة",
      "statuses": {
        "complete": "مكتمل",
        "partial": "جزئي"
      },
      "water-error": "يجب أن يكون الماء رقمًا موجبًا",
      "electricity-error": "يجب أن تكون الكهرباء عددًا موجبًا",
      "electricity-photovoltaic-error": "الكهرباء يجب أن يكون عدد الشمس موجبًا",
      "electricity-wind-error": "يجب أن يكون كهرباء الرياح رقمًا موجبًا",
      "natural-gas-error": "يجب أن يكون الغاز الطبيعي رقمًا موجبًا",
      "diesel-error": "يجب أن يكون الديزل رقمًا موجبًا",
      "gasoline-error": "يجب أن يكون البنزين رقمًا موجبًا",
      "propane-lpg-error": "يجب أن يكون البروبان / غاز البترول المسال رقمًا موجبًا",
      "coal-error": "يجب أن يكون الفحم رقمًا موجبًا"
    },
    "farm-resources-title": "استهلاك الطاقة سنويًا",
    "cycle-resources": "استهلاك الطاقة لكل دورة",
    "value": "قيمة الوزن الحي (كجم مكافئ ثاني أكسيد الكربون / كجم وزن الجسم)",
    "notification-title": "معلومات هامة حول حسابات ثاني أكسيد الكربون",
    "notification-description": "يتم حساب البصمة الكربونية بواسطة برنامج تحليل دورة الحياة Sustell. تعتمد حسابات ثاني أكسيد الكربون في الأعلاف على تعليمات Nevedi الحالية. من أجل إجراء حساب صحيح، يجب إدخال جميع البيانات بشكل كامل مثل <b>النتائج الفنية للدفعة بما في ذلك الإنتاج والمغادرة/الذبح واستهلاك الطاقة.</b>\nقد تكون القيم المعروضة عرضة للتغيير بسبب تطورات علوم المناخ والتعديلات الناتجة في أنظمة الحساب، بالإضافة إلى التغييرات في القوانين واللوائح والمعايير المعمول بها. على الرغم من أن المعلومات المعروضة هنا قد تم تجميعها بعناية، لا يمكن استنتاج أي حقوق منها.",
    "action-text-close": "يخفي",
    "action-text-open": "يعرض",
    "farm-resources-not-complete": "موارد الدورة غير مكتملة.",
    "bedding-type-required": "نوع الفراش مطلوب للدورة.",
    "bedding-amount-required": "كمية الفراش المطلوبة للدورة.",
    "start-calculation": "البدء في حساب CO2",
    "refresh-carbon-footprint": "تحديث بصمة ثاني أكسيد الكربون",
    "carbon-footprint-title-error": "خطأ في حساب البصمة الكربونية",
    "carbon-footprint-title": "حساب البصمة الكربونية",
    "carbon-footprint-text": "سيبدأ حساب البصمة الكربونية. يرجى التحلي بالصبر حتى تكتمل العملية (دقيقة واحدة تقريباً).",
    "carbon-footprint-refresh-error-title": "تعذر تحديث البصمة الكربونية",
    "carbon-footprint-refresh-error-text": "لم نتمكن من تحديث البصمة الكربونية. يرجى المحاولة مرة أخرى بعد قليل."
  },
  "bedding-type": "نوع الفراش",
  "bedding-types": {
    "NoBedding": "لا يوجد فراش",
    "BarleyStraw": "قش الشعير",
    "MaizeStover": "قش الذرة",
    "OatStraw": "قش الشوفان",
    "SawDust": "نشارة الخشب",
    "SunflowerHusk": "قشر عباد الشمس",
    "WheatStraw": "قش القمح",
    "Woodshavings": "نشارة الخشب"
  },
  "bedding-amount": "كمية الفراش",
  "bedding-amount-error": "يجب أن يكون مبلغ الفراش رقمًا موجبًا",
  "transport-distance": "النقل من المفرخة",
  "transport-distance-error": "يجب أن يكون النقل من منشأة التربية رقمًا بين 0 و1000",
  "time-in-free-range": "الوقت في النطاق الحر",
  "time-in-free-range-error": "يجب أن يكون الوقت المستغرق في النطاق الحر رقمًا بين 0 و100",
  "general-settings-error": "حدث خطأ أثناء استرداد الإعدادات لـ PoultryNEXT.",
  "tenants": {
    "Agrifirm": "أجريفيرم",
    "Agravis": "agravis"
  }
}
